import React from "react";
import TermsOfService from "../components/TermsOfService/TermsOfService";
import LegalLayout from "../components/legal/LegalLayout";

export default function TOSPage() {
  return (
    <LegalLayout
      title={
        <>
          ClearBadge™
          <br />
          <span className="legal-title-gradient">Terms of Service</span>
        </>
      }
      intro="Understand the rules that apply when you search the ClearBadge™ directory, claim your profile, or use our subscription tools."
      eyebrow="Legal Center"
    >
      <TermsOfService />
    </LegalLayout>
  );
}


